import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const getQuestions = createAsyncThunk('getQuestions', async ({ pageable: data, navigate, status }) => { try { const res = await axios({ method: 'GET',
            url: getConfig.API_URL + `question`,
            params: { 'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                ...(status ? { status } : {}),
                ...(data?.questionBankId ? { question_bank_id: data.questionBankId } : {}),
                ...(data?.questionType ? { question_type: data.questionType } : {}),
                ...(data?.questionLevel ? { question_level: data.questionLevel } : {}),
                ...(data?.instituteId ? { institute_id: data.instituteId } : {}),
            },
            headers: { "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token")
            }
        })
        return res
    } catch (error) { return error.response
    }
})

const questionListSlice = createSlice({ name: 'questionList',
    initialState: { data: [],
    },
    extraReducers: (builder) => { builder.addCase(getQuestions.fulfilled, (state, action) => { if (action?.payload?.status === 200) { state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) { showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) { showAccessDeniedAlert(action.meta.arg.navigate)
            } else { state.data = []
            }
        });
    }
})

export default questionListSlice.reducer;
